import { log3DSEvent } from '@/clients/gg/threeDSecure'
import { WorldlineVerificationStatus } from '@/travelsuit/worldline'

import { IOSMessageHandlerName, isLaunchedAsIOSApp, postMessageToIOSWebView } from './ios'
import { openExternalUrl } from './openExternalUrl'

export function redirectTo3DSVerification(redirectUrl: string) {
	log3DSEvent(redirectUrl, WorldlineVerificationStatus.RECEIVED).catch((err) => {
		console.error('Failed to log 3DS RECEIVED event', err)
	})

	const proceedToRedirect = () => {
		if (isLaunchedAsIOSApp()) {
			postMessageToIOSWebView(IOSMessageHandlerName.InitRedirectTo3ds, {
				url: redirectUrl,
			})
		} else {
			openExternalUrl(redirectUrl, '_self')
		}
	}

	log3DSEvent(redirectUrl, WorldlineVerificationStatus.REDIRECTED)
		.catch((err) => {
			console.error('Failed to log 3DS REDIRECTED event', err)
		})
		.finally(() => {
			proceedToRedirect()
		})
}
